<mat-card class="card">
  <mat-card-content>
    <h1 class="example-h2">Assessment Sticks zur Evaluierung caudaler Subluxationen (ASECS)</h1>

    <section class="input-section">
      <h2>Linke Hand:</h2>
      <mat-form-field class="example-margin example-width">
        <mat-label>Gelenkspalt in mm</mat-label>
        <input matInput type="number" min="2.5" max="30" step="2.5" [(ngModel)]="value" />
      </mat-form-field>
    </section>

    <section class="slider-section">
      <mat-slider
        class="slider"
        [disabled]="disabled"
        [max]="max"
        [min]="min"
        [step]="step"
        [discrete]="thumbLabel"
        [showTickMarks]="showTicks">
        <input matSliderThumb [(ngModel)]="value" #slider />
      </mat-slider>
    </section>

    <section class="input-section">
      <h2 class="example-h2">rechte Hand</h2>

      <mat-form-field class="example-margin example-width">
        <mat-label>Gelenkspalt in mm</mat-label>
        <input matInput type="number" min="2.5" max="30" step="2.5" [(ngModel)]="value2" />
      </mat-form-field>
    </section>

    <section class="slider-section">
      <mat-slider
        class="slider"
        [disabled]="disabled"
        [max]="max"
        [min]="min"
        [step]="step"
        [discrete]="thumbLabel"
        [showTickMarks]="showTicks">
        <input matSliderThumb [(ngModel)]="value2" #slider />
      </mat-slider>
    </section>
  </mat-card-content>
</mat-card>
